module.exports = __webpack_public_path__ + "static/media/iraq.1f220df2.svg";